import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';

export interface UpdateUserFilePayload {
  name?: string;
  description?: string;
  sensitive?: boolean;
}

async function updateUserFile(
  userUid: string,
  fileId: string,
  payload: UpdateUserFilePayload,
  auth: Authentication | null
): Promise<void> {
  try {
    if (!auth) throw new UpdateUserFileFailure('Vous devez être connecté pour effectuer cette action.', 'unauthorized');

    const response = await HttpClient.patch(
      `/backoffice/users/${userUid}/files/${fileId}`,
      payload,
      auth.token
    );

    if (!response.success) throw new UpdateUserFileFailure(response.message, response.code);
  } catch (e) {
    if (e instanceof UpdateUserFileFailure) throw e;
    const errMessage = e instanceof Error ? e.message : 'Une erreur inattendue s’est produite.';
    throw new UpdateUserFileFailure(
      errMessage.trim() || 'Erreur réseau ou serveur. Réessayez plus tard.',
      'request-failed'
    );
  }
}

export class UpdateUserFileFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default updateUserFile;
